<template>
    <div>
        <section class="main-slider">
            <div class="page-header-bg" style="background-image: url(static/picture/banner/B4.jpg);">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                        <!-- 新闻资讯 -->
                        {{ $t('news.news_banner_title') }}
                    </h1>
                    <h3>
                         <!-- 以客户的成功定义成功，赋能企业管理，来自企业的信赖 -->
                        {{ $t('news.news_banner_subtitle') }}
                    </h3>
                </div>
                <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'home' }">
                              <!-- 首页 -->
                             {{ $t('news.news_breadcrumb_home') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: 'news' }">
                             <!-- 新闻资讯 -->
                             {{ $t('news.news_breadcrumb_news') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>
                            <!-- {{ objParam.title }} -->
                            {{ $t(`news.${objParam.i18n_title}`) }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>
        <section></section>

        <!--Blog Sidebar Start-->
        <section class="blog-details">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-xl-12">
                        <div  class="blog-details_centent ">
                            <div class="blog-details_centent__title">
                                <p>
                                    <!-- {{ objParam.title }} -->
                                    {{ $t(`news.${objParam.i18n_title}`) }}
                                </p>
                            </div>
                            <div class="blog-details_centent__conter">
                                    <span class="blog-details_centent__conter_left"><i class="far fa-clock"></i> {{ objParam.time }}</span>
                            </div>
                        </div>
                    </div>
               
                </div>
                <div class="row">
                    <div class="col-lg-12 col-xl-12">
                        <div class="details__centent">
                            <!-- 内容 -->
                            <div>
                                <div class="inside-tex warp wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">                                   
                                        <div v-for="(item, index) in list" :key="index" >
                                            <p v-if="item.type=='text'" style="font-size: var(--font-size-16);white-space: normal;text-indent: 32px;line-height: 32px" >
                                                <!-- {{ item.content }} -->
                                                {{ $t(`news.${item.content}`) }}
                                            </p>
                                            <p style="text-align: center;" v-else> 
                                                <img class="details__centent_img"  :src=" item.content " title="QQ截图20230612133917.jpg" alt="QQ截图20230612133917.jpg">
                                            </p>
                                            
                                        </div>
                               
                                </div>
                            </div>
                            <div class="projectc-details__pagination-box">
                                <ul class="projectc-details__pagination list-unstyled clearfix">
                                    <li class="next">
                                            <div class="icon">
                                                <a @click="handlePrevious(objParam.previousId)"  aria-label="Previous"><i class="fa fa-long-arrow-alt-right"></i></a>
                                            </div>
                                            <div class="content">
                                                <span>
                                                    <!-- 上一条 -->
                                                    {{ $t('news.news_detail_previous') }}
                                                </span>
                                                <template v-if="objParam.previousTitle && objParam.previousId">
                                                <p class="content__p_text">
                                                    <!-- {{ objParam.previousTitle }} -->
                                                      {{ $t(`news.${objParam.i18n_previousTitle}`) }}
                                                </p>
                                                </template>
                                                <template v-else>
                                                        <p class="content__p_text">
                                                            <!-- 没有了 -->
                                                            {{ $t('news.news_detail_noMore') }}
                                                        </p>
                                                </template>
                                            </div>
                                        <!-- </template>
                                        <template>
                                            <div class="content">
                                                <span>上一条</span>
                                                <p class="content__p_text">没有了</p>
                                            </div>
                                        </template> -->
                                    </li>
                                    <li class="count"><a ></a></li>
                                    <li class="count"><a ></a></li>
                                    <li class="count"><a ></a></li>
                                    <li class="count"><a ></a></li>
                                    <li class="previous">
                                        <!-- <template v-if="objParam.nextTitle && objParam.nextId"> -->
                                            <div class="content">
                                                <span>
                                                    <!-- 下一条 -->
                                                     {{ $t('news.news_detail_next') }}
                                                </span>
                                                <template v-if="objParam.nextTitle && objParam.nextId">
                                                    <p class="content__p_text">
                                                        <!-- {{  objParam.nextTitle }} -->
                                                         {{ $t(`news.${objParam.i18n_nextTitle}`) }}
                                                    </p>
                                                </template>
                                                <template v-else>
                                                    <p class="content__p_text">
                                                        <!-- 没有了 -->
                                                        {{ $t('news.news_detail_noMore') }}
                                                    </p>
                                                </template>
                                            </div>
                                            <div class="icon">
                                                <a @click="handleNext(objParam.nextId)"  aria-label="Previous"><i class="fa fa-long-arrow-alt-right"></i></a>
                                            </div>
                                        <!-- </template>
                                        <template v-else>
                                            <div class="content">
                                                <span>没有了</span>
                                            </div>
                                        </template> -->
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--Blog Sidebar End-->
    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'newsDetail',
      mixins: [MixinsList],
    data () {
        return {
            typeIndex: 0,
            list: [],
            total: 0,
            objParam: {},
        }
    },
    created() {
        this.getData()  // 获取内容
    },
    mounted () {
           // 确定选中的菜单
        $('.current').removeClass('current');  
        $('.news_li').addClass('current');
    },
    methods: {
        // 获取数据
        async getData() {
            // var judgeId = this.$route.query.id

            // const { result } = res
            // var arr = JSON.parse(JSON.stringify(result.records))  // 新闻信息
            // var param = ""
            // if( judgeId ) {
            //     param = arr.find(item => item.id == judgeId);

            //     // arr.forEach( item => {
            //     //     // console.log("相等",item.id, judgeId )
            //     //     if(judgeId == item.id) {
            //     //         console.log("相等",item.id, judgeId )
            //     //     }
            //     // });
            // }
            // this.objParam = param
            // this.list = this.objParam.newsList


            try {

            var judgeId = this.$route.query.id
            
            const  result  = await loadData('newsData', this.lang)
            
            var arr = JSON.parse(JSON.stringify(result.records))  // 新闻信息
            var param = ""
            if( judgeId ) {
                param = arr.find(item => item.id == judgeId);

                // arr.forEach( item => {
                //     // console.log("相等",item.id, judgeId )
                //     if(judgeId == item.id) {
                //         console.log("相等",item.id, judgeId )
                //     }
                // });
            }
            this.objParam = param
            this.list = this.objParam.newsList
        } catch (error) {
                console.log(error)
            }

           

        },
        // 上一条，
        handlePrevious(value) {
            if(value) {
                this.$router.push({
                    path: "newsDetail",
                    query: {
                        id: value,
                    }
                });
            }
        },
        // 上一条，
        handleNext(value) {
            if(value) {
                this.$router.push({
                path: "newsDetail",
                query: {
                    id: value,
                }
            });
            }
           
        },
    }
}
</script>
<style scoped>
/* banner图片 */
.page-header-bg {
    background-color: transparent; 
}
.page-header__inner h1 {
    font-size: var(--font-size-40);
}
/* 详情内容 */
.blog-details {
    background: var(--notech-extra);
    padding: 60px 0 120px;
}

.blog-details_centent {
    /* margin-bottom: 60px; */
    width: 100%;
    background: #fff;
    padding: 30px 160px;
    text-align: center;
    box-shadow: 2.5px 4.33px 50px 0px rgba(30, 39, 61, 0.04);
}
/* 详情标题 */
.blog-details_centent__title {
    color: var(--notech-black);
    font-size: var(--font-size-24);
    line-height: 1.75;
    text-align: center;
}  
.blog-details_centent__conter{
    margin-top: 25px;
    line-height: 32px;
    font-size: var(--font-size-16);
    font-weight: 400;
    color: var(--notech-gray) !important;
    transition: all 500ms ease;
}
.blog-details_centent__conter i {
    color: var(--notech-primary);
    font-size: var(--font-size-16);
    padding-right: 2px;
}

/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    /* color: var(--notech-primary) !important; */
    color: var(--notech-white);
    font-size: var(--font-size-16);
    font-weight: 700;
    transition: all 500ms ease;
}

/* 内容 */
.details__centent {
    margin-top: 10px;
    background: #fff;
    padding: 45px 100px;
    box-shadow: 2.5px 4.33px 50px 0px rgba(30, 39, 61, 0.04);
}
/* 标题过长隐藏 */
.content__p_text {
    width: 300px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .icon {
    cursor: pointer;
  }
  .details__centent_img{
    max-width: 100%;
  }
</style> 
